import { createContext, useContext, useEffect, useState } from "react";

const WishCtx = createContext(null);

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => JSON.parse(localStorage.getItem("wishlist") || "[]"));
  useEffect(() => localStorage.setItem("wishlist", JSON.stringify(ids)), [ids]);
  const toggle = (id) => setIds((cur) => (cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id]));
  return <WishCtx.Provider value={{ ids, toggle, has: (id) => ids.includes(id) }}>{children}</WishCtx.Provider>;
}

export const useWishlist = () => useContext(WishCtx);
